<header *ngIf="(authenticationService.organisation$ | async)">
  <img src="{{ (authenticationService.organisation$ | async)?.logo }}" alt="{{ (authenticationService.organisation$ | async)?.display_name }}">
</header>
<fury-page-layout>
  <fury-page-layout-content @fadeInUp>
    <fury-container>
      <fury-page-layout-content-width wide="middle">
        <h1>Download de {{ (authenticationService.organisation$ | async)?.display_name }} App</h1>
        <fury-page-layout-content>
          <div fxFlex fxLayout="column">
            <h2>Wij herkennen uw besturingssysteem niet. Klik op onderstaande knop om de juiste versie te downloaden.</h2>
            <div fxFlex fxLayout="column" fxLayout.gt-xs="row">
              <a fxFlex="100" fxFlex.gt-xs="50" class="app-container" *ngIf="(authenticationService.organisation$ | async)?.play_store_url"
                 href="{{ (authenticationService.organisation$ | async)?.play_store_url }}">
                <img src="/assets/img/google-play-badge.png" alt="Play Store mobiele app URL">
              </a>
              <a fxFlex="100" fxFlex.gt-xs="50" class="app-container" *ngIf="(authenticationService.organisation$ | async)?.app_store_url"
                 href="{{ (authenticationService.organisation$ | async)?.app_store_url }}">
                <img src="/assets/img/app-store-badge.svg" alt="App Store mobiele app URL">
              </a>
            </div>
          </div>
        </fury-page-layout-content>
        <div class="white-background" *ngIf="isLoading">
          <fury-loading-overlay [isLoading]="true"></fury-loading-overlay>
        </div>
      </fury-page-layout-content-width>
    </fury-container>
  </fury-page-layout-content>
</fury-page-layout>
